import { CanMatchFn, Route, Router, UrlSegment } from "@angular/router";
import { SessionNotificationModel } from "../models/sessionNotification.model";
import { SessionService } from "../services/session.service";
import { Location } from '@angular/common';
import { inject } from "@angular/core";
import { TokenDataService } from "../services/token.data.service";
import { clearSessionData } from "../utils/clearSessionData.util";
import { LocalStorageType } from "../types/localStorage.type";

export const AuthGuard: CanMatchFn = (route: Route, segments: UrlSegment[]) => {
    const sessionNotification: SessionNotificationModel = inject(SessionService).isTokenExpiredOrNull();

    const decodedToken = inject(TokenDataService).getDecodedToken();

    if(sessionNotification.hasAccess && decodedToken) {
        return true;
    }

    clearSessionData();

    const locationPath = inject(Location).path();

    if(locationPath !== '' && locationPath !== '/blocked')
        localStorage.setItem(LocalStorageType.CallbackUrl, locationPath);

    inject(Router).navigate(['/login']);

    return false;
};